var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserRecord = function SvgUserRecord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".user-record_svg__cls-3{fill:#565656}"))), /*#__PURE__*/React.createElement("g", {
    id: "user-record_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 6C10.5 6 6 10.5 6 16s4.5 10 10 10 10-4.5 10-10S21.5 6 16 6Zm0 2c4.4 0 8 3.6 8 8s-3.6 8-8 8-8-3.6-8-8 3.6-8 8-8Z",
    style: {
      fill: "#fff!important"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 1.1C7.8 1.1 1.1 7.8 1.1 16S7.8 30.9 16 30.9 30.9 24.2 30.9 16 24.2 1.1 16 1.1Zm0 3c6.6 0 11.9 5.3 11.9 11.9S22.6 27.9 16 27.9 4.1 22.6 4.1 16 9.4 4.1 16 4.1Z",
    style: {
      fill: "#ea2134!important"
    }
  })));
};
export default SvgUserRecord;